module.exports = __webpack_public_path__ + "static/redmine-f79532e11f565a4cf4c2e341e270796b.svg";